import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserAgreementStatus } from '../../services/termsApi/termsApi';
import { SessionManager } from '../../utils/SessionManager';
import { useSnackbar, SnackbarType } from '../../contexts/SnackbarProvider';

export const useTermsAgreementGuard = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [hasChecked, setHasChecked] = useState<boolean>(false);
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();

  useEffect(() => {
    checkAgreementStatus();
  }, []);

  const checkAgreementStatus = async () => {
    try {
      setLoading(true);
      
      // ログインしているかチェック
      const token = SessionManager.getToken();
      if (!token) {
        setLoading(false);
        setHasChecked(true);
        return;
      }

      // 利用規約同意状況をチェック
      const response = await getUserAgreementStatus();
      
      if (!response.has_agreed_to_current) {
        setShowModal(true);
      } 
      
      setHasChecked(true);
    } catch (error: any) {
      
      // 認証エラー（401/403）の場合は、セッションがクリアされているはずなので、
      // ログインページにリダイレクトする
      if (error?.response && (error.response.status === 401 || error.response.status === 403)) {
        setHasChecked(true);
      } else {
        // その他のエラーの場合は、安全のため利用規約モーダルを表示
        setShowModal(true);
        setHasChecked(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAgree = () => {
    setShowModal(false);
    showSnackbar('MedTubeをご利用いただき、ありがとうございます', SnackbarType.SUCCESS);
  };

  const handleDecline = () => {
    setShowModal(false);
    
    // 同意しない場合はログアウトしてログインページへ
    SessionManager.clearSession();
    showSnackbar('利用規約への同意が必要です', SnackbarType.WARNING);
    navigate('/login');
  };

  return {
    showModal,
    loading,
    hasChecked,
    handleAgree,
    handleDecline,
  };
};